/* Next Play — scroll reveals + stat count-ups.
   Progressive enhancement only: classes are added here, so no JS = no hiding. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;

  /* ── Scroll reveals with sibling stagger ── */
  var REVEAL_SELECTOR = [
    '.np-format__card', '.np-pillar', '.np-who__card', '.np-wyg__item',
    '.np-event__stat', '.np-problem__stat', '.np-trust__col',
    '.np-schedule__day', '.np-faq__item', '.np-event__spec-item',
    '.np-pillars__header', '.np-format__header', '.np-problem__header',
    '.np-who__header', '.np-wyg__header', '.np-trust__header',
    '.np-event__header', '.np-schedule__header', '.np-faq__header',
    '.np-quote__container', '.np-cta__container',
    '.np-partners__header', '.np-partners__card',
    '.np-partners-strip__container', '.np-trust__media', '.np-wyg__media'
  ].join(',');

  var els = document.querySelectorAll(REVEAL_SELECTOR);
  els.forEach(function (el) { el.classList.add('np-reveal'); });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var parent = el.parentElement;
      var delay = 0;
      if (parent) {
        var peers = Array.prototype.filter.call(parent.children, function (c) {
          return c.classList.contains('np-reveal');
        });
        var idx = peers.indexOf(el);
        if (idx > 0) delay = Math.min(idx * 70, 350);
      }
      el.style.transitionDelay = delay + 'ms';
      el.classList.add('np-reveal--in');
      io.unobserve(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  els.forEach(function (el) { io.observe(el); });

  /* ── Stat count-ups ── */
  var counters = document.querySelectorAll('.np-problem__value, .np-event__value');
  if (!counters.length) return;

  var io2 = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      io2.unobserve(entry.target);
      countUp(entry.target);
    });
  }, { threshold: 0.6 });

  counters.forEach(function (el) { io2.observe(el); });

  function countUp(el) {
    var original = el.textContent.trim();
    var m = original.match(/^([^0-9]*)([\d,]+)(.*)$/);
    if (!m) return; // no digits (e.g. "Free") — leave untouched
    var target = parseInt(m[2].replace(/,/g, ''), 10);
    if (!target || target < 2) return;
    var prefix = m[1];
    var suffix = m[3];
    var useCommas = m[2].indexOf(',') > -1;
    var duration = 1200;
    var start = null;

    function fmt(n) { return useCommas ? n.toLocaleString('en-US') : String(n); }

    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + fmt(Math.round(target * eased)) + suffix;
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = original; // guarantee exact final value
      }
    }
    requestAnimationFrame(step);
  }
})();

/* Desktop nav: parent items with a dropdown are triggers, not links.
   Clicking "For Athletes" should open the menu, never navigate — the
   destinations live in the children (College / High School). Scoped to
   .header-menu so the mobile drawer keeps its own accordion behavior.
   Separate IIFE: must run even when prefers-reduced-motion applies. */
(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.header-menu .menu-list__link[aria-haspopup="true"]');
    if (trigger) e.preventDefault();
  });
})();
